import { render, staticRenderFns } from "./NotificationsManagement.vue?vue&type=template&id=7c9bde4c&scoped=true"
import script from "./NotificationsManagement.vue?vue&type=script&lang=ts"
export * from "./NotificationsManagement.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7c9bde4c",
  null
  ,true
)

export default component.exports